import React from 'react'
import moment from 'moment'
import * as htmlToImage from 'html-to-image'
import ReactPaginate from 'react-paginate'
import { Button, Box, Text, Flex, Checkbox } from '@chakra-ui/react'
import { useParams, useLocation } from 'react-router-dom'
import { MdArrowBackIos } from 'react-icons/md'
import Mau1 from './components/mau1'
import Mau2 from './components/mau2'
import Mau3 from './components/mau3'
import Mau4 from './components/mau4'
import Mau5 from './components/mau5'
import Mau6 from './components/mau6'
import Mau7 from './components/mau7'
import Mau8 from './components/mau8'
import { MdUpdate } from 'react-icons/md'
import imgbg from '../../../public/static/image-background/mau1Semifinal.jpeg'
import imgbg2 from '../../../public/static/image-background/c2choosemausemifinal.jpeg'
import newConceptThumbnail from '../../../public/static/image-background/newConceptThumbnail.png'
import newConceptThumbnail2 from '../../../public/static/image-background/newConceptThumbnail2.png'
import newConceptThumbnail3 from '../../../public/static/image-background/newConceptThumbnail3.png'
import newConceptThumbnail4 from '../../../public/static/image-background/newConceptThumbnail4.png'
import newConceptThumbnail5 from '../../../public/static/image-background/newConceptThumbnail5.png'
import newConceptThumbnail6 from '../../../public/static/image-background/newConceptThumbnail6.png'
import semifinalen1 from '../../../public/static/image-background/semifinalen1.jpeg'
import semifinalen2 from '../../../public/static/image-background/semifinalen2.jpeg'

import { getBase64, useTranslation } from '../../../constants/helpers'

import * as leaguesAPI from '../../../api/leagues'
import { BrowserRouter, Routes, Route, useSearchParams } from 'react-router-dom'

const ExportSchedules = () => {
  const { t } = useTranslation()
  let { leagueId, seasonId } = useParams()
  const [searchParams] = useSearchParams()
  const numberRound = searchParams.get('numberRound')
  // const {isOpen, onOpen, onClose} = useDisclosure()
  const [type, setType] = React.useState(null)
  const [state, setState] = React.useState({
    downloading: false,
    loading: true,
    loadingTeam: true,
    loadingSeason: true,
    loadingSchelues: true,
    dataSchedules: [],
    dataSeason: {},
    dataSponsor: [],
    loadingSponsor: true,
    showSponsor: true
  })
  const [show, setShow] = React.useState(false)
  const [selected, setSelected] = React.useState(0)

  const lang = window.sessionStorage.getItem('lang')
  const thumbnailImg = {
    imgbg1: {
      en: semifinalen1,
      vi: imgbg
    },

    imgbg2: {
      en: semifinalen2,
      vi: imgbg2
    }
  }
  const mau1 = React.useRef(new Date().toISOString() + 'match')
  const mau2 = React.useRef(new Date().toISOString() + 'match')
  const mau3 = React.useRef(new Date().toISOString() + 'match')
  const mau4 = React.useRef(new Date().toISOString() + 'match')
  const mau5 = React.useRef(new Date().toISOString() + 'match')
  const mau6 = React.useRef(new Date().toISOString() + 'match')
  const mau7 = React.useRef(new Date().toISOString() + 'match')
  const mau8 = React.useRef(new Date().toISOString() + 'match')

  const idMau1 = mau1.current
  const idMau2 = mau2.current
  const idMau3 = mau3.current
  const idMau4 = mau4.current
  const idMau5 = mau5.current
  const idMau6 = mau6.current
  const idMau7 = mau7.current
  const idMau8 = mau8.current

  const select = value => () => {
    setSelected(value)
    setShow(true)
  }
  const fetchData = React.useCallback(() => {
    leaguesAPI
      .getSchedulesBySeasonIdV2(leagueId, seasonId, numberRound, 'all', 'all', 'all')
      .then(res => {
        setState(s => ({ ...s, dataSchedules: res, loadingSchelues: false }))
      })
      .catch(e => {
        setState(s => ({ ...s, loadingSchelues: false }))
        console.log('error', e)
      })
    leaguesAPI
      .getSeasonByIdSeasonAndIdLeague(leagueId, seasonId)
      .then(res => {
        setState(s => ({ ...s, dataSeason: res, loadingSeason: false }))
      })
      .catch(e => {
        setState(s => ({ ...s, loadingSeason: false }))
        console.log('error', e)
      })
    leaguesAPI
      .getSponsor(leagueId, seasonId)
      .then(r => {
        const dataTemp = r.reduce((p, n) => {
          if (n.sponsors.length) {
            p = [...p, ...n.sponsors]
          }
          return p
        }, [])
        setState(s => ({ ...s, dataSponsor: dataTemp, loadingSponsor: false }))
      })
      .catch(e => {
        setState(s => ({ ...s, loadingSponsor: false }))
      })
  }, [leagueId, numberRound])

  React.useEffect(() => {
    fetchData()
  }, [fetchData])
  const handleChangeCheckbox = ({ target }) => {
    setState(s => ({ ...s, [target.name]: target.checked }))
  }
  React.useEffect(() => {
    switch (selected) {
      case 1:
        setType(mau1.current)
        break
      case 2:
        setType(mau2.current)
        break
      case 3:
        setType(mau3.current)
        break
      case 4:
        setType(mau4.current)
        break
      case 5:
        setType(mau5.current)
        break
      case 6:
        setType(mau6.current)
        break
      case 7:
        setType(mau7.current)
        break
      case 8:
        setType(mau8.current)
        break
      default:
        break
    }
  }, [selected])

  const css = {
    cursor: 'pointer',
    border: '2px solid transparent',
    borderRadius: '12px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    backgroundColor: '#ffffff',
    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
    overflow: 'hidden',
    transition: 'all 0.2s ease-in-out',
    aspectRatio: '1 / 1'
  }
  /////////////
  ///////////
  /////////
  ///////

  const exportImage = async () => {
    if (state.downloading) return
    setState(s => ({ ...s, downloading: true }))
    htmlToImage
      .toJpeg(document.getElementById(type), { pixelRatio: 3, quality: 1 })
      .then(dataUrl => {
        var link = document.createElement('a')
        const timeStamp = moment().format('yyyyMMDDHHmmss')
        const text = {
          vi: 'LichThiDau',
          en: 'Schedules'
        }
        const nameRound = `${t(numberRound)}`
        link.download = `${text[lang]}_${nameRound}_${timeStamp}.jpeg`
        link.href = dataUrl
        link.click()
        setState(s => ({ ...s, downloading: false }))
      })
      .catch(function (error) {
        setState(s => ({ ...s, downloading: false }))
        console.error('oops, something went wrong!', error)
      })
  }
  React.useEffect(() => {
    // Send `message` to the parent using the postMessage method on the window.parent reference.
    window.parent.postMessage('exportSchedulesSemiFinal', '*')
  }, [])

  if (state.loadingSeason || state.loadingSchelues) {
    return (
      <Box height={'50vh'} display="flex" flexDirection={'column'} alignItems={'center'} justifyContent="center">
        <Text> Loading . . . !</Text>
      </Box>
    )
  }
  if (show) {
    return (
      <Box>
        <Flex display={'flex'} flexDirection="row" justifyContent={'space-between'}>
          <Box
            display={'flex'}
            flexDirection={'row'}
            mb={3}
            onClick={() => {
              setShow(false)
            }}
            cursor="pointer">
            <MdArrowBackIos size={'28px'} />
            <Text>{t('back')}</Text>
          </Box>
          <Flex display="flex" flexDirection={'row'} justifyContent="flex-end">
            {state.dataSponsor.length > 0 && selected === 1 && (
              <Checkbox textTransform={'capitalize'} mr={2} name={'showSponsor'} colorScheme="green" isChecked={state.showSponsor} onChange={handleChangeCheckbox}>
                {t('sponsor')}
              </Checkbox>
            )}
            <Button ml={4} isLoading={state.downloading} colorScheme="blue" onClick={exportImage}>
              {t('download')}
            </Button>
          </Flex>
        </Flex>
        <Flex mt={4} display={'flex'} flexDirection="row" justifyContent={'center'}>
          <Box>
            <Box maxWidth={'920px'} margin="0 auto" display="flex" flexDirection={'column'} justifyContent="center">
              {selected === 1 && (
                <>
                  <div style={{ overflow: 'scroll', width: 0, height: 0 }}>
                    <Mau1 dataSeason={state.dataSeason} dataSchedules={state.dataSchedules} id={idMau1} size={1800} numberRound={numberRound} isShowSponsor={state.showSponsor} sponsorData={state.dataSponsor} />
                  </div>
                  <Mau1 dataSeason={state.dataSeason} dataSchedules={state.dataSchedules} size={900} numberRound={numberRound} isShowSponsor={state.showSponsor} sponsorData={state.dataSponsor} />
                </>
              )}
              {selected === 2 && (
                <>
                  <div style={{ overflow: 'scroll', width: 0, height: 0 }}>
                    <Mau2 dataSeason={state.dataSeason} dataSchedules={state.dataSchedules} id={idMau2} size={1800} numberRound={numberRound} isShowSponsor={state.showSponsor} sponsorData={state.dataSponsor} />
                  </div>
                  <Mau2 dataSeason={state.dataSeason} dataSchedules={state.dataSchedules} size={900} numberRound={numberRound} isShowSponsor={state.showSponsor} sponsorData={state.dataSponsor} />
                </>
              )}
              {selected === 3 && (
                <>
                  <div style={{ overflow: 'scroll', width: 0, height: 0 }}>
                    <Mau3 dataSeason={state.dataSeason} dataSchedules={state.dataSchedules} id={idMau3} size={1800} numberRound={numberRound} isShowSponsor={state.showSponsor} sponsorData={state.dataSponsor} />
                  </div>
                  <Mau3 dataSeason={state.dataSeason} dataSchedules={state.dataSchedules} size={900} numberRound={numberRound} isShowSponsor={state.showSponsor} sponsorData={state.dataSponsor} />
                </>
              )}
              {selected === 4 && (
                <>
                  <div style={{ overflow: 'scroll', width: 0, height: 0 }}>
                    <Mau4 dataSeason={state.dataSeason} dataSchedules={state.dataSchedules} id={idMau4} size={1800} numberRound={numberRound} isShowSponsor={state.showSponsor} sponsorData={state.dataSponsor} />
                  </div>
                  <Mau4 dataSeason={state.dataSeason} dataSchedules={state.dataSchedules} size={900} numberRound={numberRound} isShowSponsor={state.showSponsor} sponsorData={state.dataSponsor} />
                </>
              )}
              {selected === 5 && (
                <>
                  <div style={{ overflow: 'scroll', width: 0, height: 0 }}>
                    <Mau5 dataSeason={state.dataSeason} dataSchedules={state.dataSchedules} id={idMau5} size={1800} numberRound={numberRound} isShowSponsor={state.showSponsor} sponsorData={state.dataSponsor} />
                  </div>
                  <Mau5 dataSeason={state.dataSeason} dataSchedules={state.dataSchedules} size={900} numberRound={numberRound} isShowSponsor={state.showSponsor} sponsorData={state.dataSponsor} />
                </>
              )}
              {selected === 6 && (
                <>
                  <div style={{ overflow: 'scroll', width: 0, height: 0 }}>
                    <Mau6 dataSeason={state.dataSeason} dataSchedules={state.dataSchedules} id={idMau6} size={1800} numberRound={numberRound} isShowSponsor={state.showSponsor} sponsorData={state.dataSponsor} />
                  </div>
                  <Mau6 dataSeason={state.dataSeason} dataSchedules={state.dataSchedules} size={900} numberRound={numberRound} isShowSponsor={state.showSponsor} sponsorData={state.dataSponsor} />
                </>
              )}
              {selected === 7 && (
                <>
                  <div style={{ overflow: 'scroll', width: 0, height: 0 }}>
                    <Mau7 dataSeason={state.dataSeason} dataSchedules={state.dataSchedules} id={idMau7} size={1800} numberRound={numberRound} isShowSponsor={state.showSponsor} sponsorData={state.dataSponsor} />
                  </div>
                  <Mau7 dataSeason={state.dataSeason} dataSchedules={state.dataSchedules} size={900} numberRound={numberRound} isShowSponsor={state.showSponsor} sponsorData={state.dataSponsor} />
                </>
              )}
              {selected === 8 && (
                <>
                  <div style={{ overflow: 'scroll', width: 0, height: 0 }}>
                    <Mau8 dataSeason={state.dataSeason} dataSchedules={state.dataSchedules} id={idMau8} size={1800} numberRound={numberRound} isShowSponsor={state.showSponsor} sponsorData={state.dataSponsor} />
                  </div>
                  <Mau8 dataSeason={state.dataSeason} dataSchedules={state.dataSchedules} size={900} numberRound={numberRound} isShowSponsor={state.showSponsor} sponsorData={state.dataSponsor} />
                </>
              )}
            </Box>
          </Box>
        </Flex>
      </Box>
    )
  } else {
    return (
      <Box height={'100%'} display="flex" flexDirection={'column'}>
        <Box display="grid" gridTemplateColumns="repeat(4, 1fr)" gap="16px" w="100%">
          <Box _hover={{ borderColor: '#11368f !important', transform: 'translateY(-4px)', boxShadow: '0 8px 16px rgba(0,0,0,0.2)' }} style={css} className="pointer" onClick={select(1)}>
            <Image style={{ height: '100%', width: '100%', objectFit: 'cover', margin: '0 auto' }} src={thumbnailImg['imgbg1'][lang]} />
          </Box>
          <Box _hover={{ borderColor: '#11368f !important', transform: 'translateY(-4px)', boxShadow: '0 8px 16px rgba(0,0,0,0.2)' }} bgColor="#eeeeee" style={css} display="flex" flexDirection="column" justifyContent="center" className="pointer" onClick={select(2)}>
            <Image style={{ width: '100%', height: '100%', margin: '0 auto', objectFit: 'contain' }} src={thumbnailImg['imgbg2'][lang]} />
          </Box>
          <Box _hover={{ borderColor: '#11368f !important', transform: 'translateY(-4px)', boxShadow: '0 8px 16px rgba(0,0,0,0.2)' }} style={css} className="pointer" onClick={select(3)}>
            <Image style={{ width: '100%', height: '100%', objectFit: 'cover', margin: '0 auto' }} src={newConceptThumbnail} />
          </Box>
          <Box _hover={{ borderColor: '#11368f !important', transform: 'translateY(-4px)', boxShadow: '0 8px 16px rgba(0,0,0,0.2)' }} style={css} className="pointer" onClick={select(4)}>
            <Image style={{ width: '100%', height: '100%', objectFit: 'cover', margin: '0 auto' }} src={newConceptThumbnail2} />
          </Box>
          <Box _hover={{ borderColor: '#11368f !important', transform: 'translateY(-4px)', boxShadow: '0 8px 16px rgba(0,0,0,0.2)' }} style={css} className="pointer" onClick={select(5)}>
            <Image style={{ width: '100%', height: '100%', objectFit: 'cover', margin: '0 auto' }} src={newConceptThumbnail3} />
          </Box>
          <Box _hover={{ borderColor: '#11368f !important', transform: 'translateY(-4px)', boxShadow: '0 8px 16px rgba(0,0,0,0.2)' }} style={css} className="pointer" onClick={select(6)}>
            <Image style={{ width: '100%', height: '100%', objectFit: 'cover', margin: '0 auto' }} src={newConceptThumbnail4} />
          </Box>
          <Box _hover={{ borderColor: '#11368f !important', transform: 'translateY(-4px)', boxShadow: '0 8px 16px rgba(0,0,0,0.2)' }} style={css} className="pointer" onClick={select(7)}>
            <Image style={{ width: '100%', height: '100%', objectFit: 'cover', margin: '0 auto' }} src={newConceptThumbnail5} />
          </Box>
          <Box _hover={{ borderColor: '#11368f !important', transform: 'translateY(-4px)', boxShadow: '0 8px 16px rgba(0,0,0,0.2)' }} style={css} className="pointer" onClick={select(8)}>
            <Image style={{ width: '100%', height: '100%', objectFit: 'cover', margin: '0 auto' }} src={newConceptThumbnail6} />
          </Box>
        </Box>
      </Box>
    )
  }
}

const Image = props => {
  const [data, setData] = React.useState(null)
  React.useEffect(() => {
    getBase64(props.src).then(r => {
      setData(r)
    })
  }, [props.src])
  return <img {...props} src={data} alt="" />
}

function areEqual(p, n) {
  return true
}

export default React.memo(ExportSchedules, areEqual)
